export default "__VITE_ASSET__C6CaF7n0__"